import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchCustomerPersonalData(id) {
  const url = `/contacts/clients/${id}/general-values/`;
  const response = await httpManager.get(url);

  return response.data;
}
